export default "__VITE_ASSET__gunNVLx6__"